<template>
<b-container class="">
  <b-row align-h="start">
  <h1>Convert HEX to ASM / JS</h1>
  </b-row>
  <b-row>
  <h2>Here paste the HEX</h2>
  </b-row>
  <b-row>
      <b-form-textarea id="textarea1"
                     v-model="text"
                     placeholder="Paste HEX, or drag text file here"
                     :rows="3"
                     :max-rows="6">
    </b-form-textarea>
    </b-row>
    <b-row>
      <h5>Number format: </h5>
      <b-form-radio-group id="radios1"
          v-model="mode"
        :options="options"></b-form-radio-group>
    </b-row>
  <b-row>
      <h5>Output type:  </h5>
      <b-form-radio-group id="radios2"
          v-model="format"
        :options="foptions"></b-form-radio-group>
    </b-row>
  <b-row>
  <h2>Here is the output text</h2>
  </b-row>
    <b-row>
      <div class="sourceout">{{textout}}</div>
    <b-form-textarea id="textarea2"
                     readonly
                     v-model="textout"
                     :rows="10"
                     :max-rows="15">
    </b-form-textarea>
    </b-row>
</b-container>
</template>

<script>

var doDrag = function (_this) {
  var holder = document.getElementById('textarea1')

  holder.ondragover = function () {
    this.className = 'form-control';
    return false;
  };
  holder.onmouseleave = function () {
    this.className = 'form-control';
    return false;
  };
  holder.ondrop = function (e) {
    this.className = 'form-control';
    e.preventDefault();

    var file = e.dataTransfer.files[0]
    var reader = new FileReader();
    reader.onload = function (event) {
      _this.text = event.target.result;
    };
    reader.readAsText(file);

    return false;
  };
}

var hexLine = function (ln) {
  let out = {}
  if (ln[0] !== ':') return false;
  var len = parseInt(ln[1] + ln[2], 16);
  var start = parseInt(ln[3] + ln[4] + ln[5] + ln[6], 16);
  var typ = parseInt(ln[7] + ln[8], 16);
  out.len = len
  out.start = start
  if (typ === 0) {
    out.data = [];
    for (let i = 0; i < len; i++) {
      out.data[i] = parseInt(ln[9 + 2 * i] + ln[10 + 2 * i], 16);
    }
  }
  return out;
}

var pad = function (data, mode, len = 2) {
  if (mode === 'dec') return data;
  let n = data.toString(16).toUpperCase();
  while (n.length < len) n = '0' + n;
  if (mode === 'hex') return '$' + n
  if (mode === '0x') return '0x' + n
  if (mode === 'xxx') return n
}

export default {
  name: 'hex2asm',
  components: {},
  data () {
    return {
      text: '',
      mode: 'hex',
      options: [
        { text: 'HEX ($)', value: 'hex' },
        { text: 'HEX (0x)', value: '0x' },
        { text: 'DEC', value: 'dec' }
      ],
      format: 'asm',
      foptions: [
        { text: 'ASM', value: 'asm' },
        { text: 'JS array', value: 'js' },
        { text: 'Arduino / C', value: 'ard' }
      ]
    }
  },
  computed: {
    textout: {
      get () {
        var ln = this.text.split('\n')
        var out = '';
        var org = null;

        if (this.format === 'asm') {
          for (let i = 0; i < ln.length; i++) {
            let hl = hexLine(ln[i]);
            if (!hl) continue;
            if (hl.len === 0) continue;
            if (org !== hl.start) {
              out += '    .org ' + pad(hl.start, this.mode, 4) + '\n';
              org = hl.start;
            }
            out += '    .db '
            for (let j = 0; j < hl.len; j++) {
              out += pad(hl.data[j], this.mode)
              if (j < (hl.len - 1)) out += ', '
            }
            out += '\n'
            org += hl.len
          }
        }

        if (this.format === 'js') {
          let mode = this.mode
          if (mode === 'hex') mode = '0x'
          for (let i = 0; i < ln.length; i++) {
            let hl = hexLine(ln[i]);
            if (!hl) continue;
            if (hl.len === 0) continue;
            if (org !== hl.start) {
              if (org !== null) { out += '];\n' }
              out += 'var n_' + pad(hl.start, 'xxx', 4) + ' = [\n';
              org = hl.start;
            }
            out += '/* ' + pad(org, 'xxx', 4) + ' */  '
            for (let j = 0; j < hl.len; j++) {
              out += pad(hl.data[j], mode)
              out += ', '
            }
            out += '\n'
            org += hl.len
          }
          if (org) out += '];\n'
        }

        if (this.format === 'ard') {
          let mode = this.mode
          let bytes = 0;
          var p;
          if (mode === 'hex') mode = '0x'
          for (let i = 0; i < ln.length; i++) {
            let hl = hexLine(ln[i]);
            if (!hl) continue;
            if (hl.len === 0) continue;
            if (org !== hl.start) {
              if (org !== null) {
                out += '};\n';
                p = out.lastIndexOf('~');
                out = out.substr(0, p) + pad(bytes, mode) + out.substr(p + 1);
                bytes = 0;
              }
              out += 'const byte PROGMEM n_' + pad(hl.start, 'xxx', 4) + '[~] = {\n';
              org = hl.start;
            }
            out += '/* ' + pad(org, 'xxx', 4) + ' */  '
            for (let j = 0; j < hl.len; j++) {
              out += pad(hl.data[j], mode)
              out += ', '
              bytes++;
            }
            out += '\n'
            org += hl.len
          }
          if (org) out += '};\n'
          p = out.lastIndexOf(',');
          out = out.substr(0, p) + out.substr(p + 1)
          p = out.lastIndexOf('~');
          out = out.substr(0, p) + pad(bytes, mode) + out.substr(p + 1)
        }

        return out;
      },
      set () { return }
    }
  },
  mounted () {
    doDrag(this)
  }
}
</script>

<style>
textarea {font-family: monospace !important;}
</style>
